import { useTranslation } from "react-i18next";

const DEFAULT_LANGUAGES = ["fr", "en"];

const WRAP = {
  default:
    "inline-flex gap-1 rounded-md border border-v2-border bg-v2-card p-1",
  login:
    "inline-flex gap-1 rounded-md border border-[rgba(98,94,166,0.62)] bg-[rgba(17,12,61,0.72)] p-[3px]",
  topbar:
    "mr-[3px] inline-flex gap-1 rounded-md border border-[rgba(98,94,166,0.55)] bg-[rgba(17,12,61,0.6)] p-0.5 max-[650px]:hidden",
};

const BTN = {
  default:
    "rounded border-0 bg-transparent px-3 py-1.5 text-[11px] font-bold tracking-[0.08em] text-v2-subtle data-[active=true]:bg-v2-accent data-[active=true]:text-v2-foreground",
  login:
    "min-w-[28px] rounded border-0 bg-transparent px-[7px] py-[5px] text-[10px] font-bold tracking-[0.08em] text-v2-subtle data-[active=true]:bg-v2-accent data-[active=true]:text-v2-foreground",
  topbar:
    "min-w-[26px] rounded border-0 bg-transparent px-1.5 py-[5px] text-[9px] font-bold tracking-[0.08em] text-v2-subtle data-[active=true]:bg-v2-accent data-[active=true]:text-v2-foreground",
};

export default function LanguageSwitcher({
  languages = DEFAULT_LANGUAGES,
  className = "",
  size = "default",
}) {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || "fr").slice(0, 2);
  const wrap = WRAP[size] || WRAP.default;
  const btn = BTN[size] || BTN.default;

  return (
    <div
      className={`${wrap} ${className}`.trim()}
      role="group"
      aria-label={t("v2.language.label")}
    >
      {languages.map((language) => (
        <button
          key={language}
          type="button"
          className={btn}
          data-active={current === language}
          aria-pressed={current === language}
          onClick={() => i18n.changeLanguage(language)}
        >
          {language.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
